'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _combineStyles = require('../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = function root() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors2.default.theme;
  var avatar = arguments[1];
  var overrideStyle = arguments[2];

  var style = _extends({}, _styles2.default.profileCard, { backgroundColor: color });

  if (avatar) {
    return (0, _combineStyles2.default)((0, _combineStyles2.default)(style, _styles2.default.withAvatar), overrideStyle);
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var avatar = function avatar() {
  return _styles2.default.avatar;
};

exports.default = {
  root: root,
  avatar: avatar
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/profile-card/get-styles.js
// module id = 931
// module chunks = 0